import { Component, OnInit, ViewEncapsulation, ViewChild, OnChanges, OnDestroy} from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '../../../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { v_InventoryBus } from '../../../shared/models/v_InventoryBus';
import { InventoryBus } from '../../../shared/models/InventoryBus';
import { InventoryReference } from '../../../shared/models/InventoryReference';
import * as _ from 'lodash';
import { BaseAppMComponent } from '../../../shared/base-components/base-app-m.component';
import { CommonFunctions } from '../../../shared/static/common-functions';
import { FileInfo } from '@progress/kendo-angular-upload';
import { BaseMessageInfo } from '../../../shared/models/BaseMessageInfo';
import { CmProAuthService } from '../../../../core/services';

import { Align } from "@progress/kendo-angular-popup";
import { StockReplenishmentBus, StockReplenishmentsBus } from '../../../shared/models/StockReplenishmentsBus';
import { StockReplenishmentDetailComponent } from '../stock-replenishment-detail/stock-replenishment-detail.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';

@Component({
    selector: 'stock-replenishment',
    templateUrl: './stock-replenishment.component.html',
    styleUrls: ['./stock-replenishment.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class StockReplenishmentComponent extends BaseAppMComponent<InventoryBus, InventoryService, null, null> implements OnChanges, OnInit, OnDestroy {
    myFiles1: Array<FileInfo> = [];
    public imagePreviews: any[] = [];
    partPhoto: any;
    inventorySearch: boolean = false;
    inventorySearching: boolean = false;
    inventorySearchMerge: boolean = false;
    subs_data_search: Subscription;
    appCode: string = "Parts";
    //    originalData: v_InventoryBus;
    inventoryReferenceData: InventoryReference = new InventoryReference();
    subs_data_ref: Subscription;
    readOnly: boolean = false;
    id: string = null;
    loadingThings: boolean = false;
    public anchorAlign: Align = { horizontal: "right", vertical: "bottom" };
    public popupAlign: Align = { horizontal: "right", vertical: "top" };

    //testingData
    //public items: any[] = [
    //    { title: 'Flower', url: 'https://bit.ly/2cJjYuB' },
    //    { title: 'Mountain', url: 'https://bit.ly/2cTBNaL' },
    //    { title: 'Sky', url: 'https://bit.ly/2cJl3Cx' }
    //];
    public width = '100%';
    public height = '200px';
    public hasPhotos: boolean = false;
    public hasMergePhotos: boolean = false;

    @ViewChild("stockReplenishmentDetailBranch") stockReplenishmentDetailBranch: StockReplenishmentDetailComponent;
    @ViewChild("stockReplenishmentDetailPerson") stockReplenishmentDetailPerson: StockReplenishmentDetailComponent;

    searchValue: string = "";
    searchMergeValue: string = "";
    persons: StockReplenishmentBus[];
    branches: StockReplenishmentBus[];

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, _qry_rd: DQOIReferenceDataQuery, svc_data: InventoryService, private authService: CmProAuthService) {
        super(globals, featureFlagService, _qry_rd);
        this.svc_data = svc_data;
        this.createForm();
        this.height = (window.innerHeight - 200).toString() + "px";
    }
    public editForm: FormGroup;

    override ngOnInit() {
        super.ngOnInit();
        if (this.subs_data_ref !== undefined && this.subs_data_ref !== null) {
            this.subs_data_ref.unsubscribe();
        }
        this.subs_data_ref = this.svc_data.getReferenceData().subscribe(data => {

            this.inventoryReferenceData = new InventoryReference(data);
        });
        this.loadData();
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.readOnly = !user.appClaims.MaintainParts;
            }
        });
    }
    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.authService.unsubscribeToLoginEvents();
    }

    photoViewer: boolean = false;
    closePhotoViewer() { this.photoViewer = false; }
    openPhotoViewer() { this.photoViewer = true; }
    loadData() {
        this.loadingThings = true;
        this.svc_data.getStockReplenishments().subscribe((data: BaseMessageInfo) => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data.primaryReturn.branches)) {
                for (let i = 0; i < data.primaryReturn.branches.length; i++) {
                    let newObj: StockReplenishmentBus = new StockReplenishmentBus(data.primaryReturn.branches[i]);
                    arr.push(newObj);
                }
            }

            this.branches = arr;

            let arrp = [];
            if (CommonFunctions.hasArrayValue(data.primaryReturn.persons)) {
                for (let i = 0; i < data.primaryReturn.persons.length; i++) {
                    let newObj: StockReplenishmentBus = new StockReplenishmentBus(data.primaryReturn.persons[i]);
                    arrp.push(newObj);
                }
            }

            this.persons = arrp;

            this.loadingThings = false;

        });

    }
    stagingWarehouseHasQty = false;
    partsToMove = 0;
    impactValue = 0;

    createForm() {
        this.editForm = new FormGroup({
            //            'customerId': new FormControl(),
            'inventoryId': new FormControl(),
            'number': new FormControl(''),
            'warrantyEndDate': new FormControl(),
            'serialNbr': new FormControl(),
            'model': new FormControl(),
            'manufacturerNumber': new FormControl(),
            'fullDescription': new FormControl('', Validators.required),
            'inventoryDesc': new FormControl('', Validators.required),
            'nonPart': new FormControl(),
            'isCommon': new FormControl(),
            'isActive': new FormControl(),
            'inventoryTypeId': new FormControl('', Validators.required),
            'inventoryCategoryId': new FormControl('', Validators.required),
            'inventorySubCategoryId': new FormControl(),
            'manufacturerId': new FormControl(),
            'manufacturerTypeId': new FormControl(),
            'incomeAccountId': new FormControl('', Validators.required),
            'inventoryAccountId': new FormControl('', Validators.required),
            'costAccountId': new FormControl('', Validators.required),
            'notes': new FormControl(),
            'minThreshold': new FormControl(),
            'maxThreshold': new FormControl(),
            'currentCost': new FormControl(),
            'maxCost': new FormControl(),
            'avgCost': new FormControl(),
            'lastCost': new FormControl(),
            'flatCost': new FormControl(),
            'internationalCost': new FormControl(),
            'defaultPrice': new FormControl(),
            'ratio': new FormControl(),
            'retired': new FormControl(),
            'installedOn': new FormControl(),
            'cycleCountClassId': new FormControl('', Validators.required),
        });

    }
     save() {

        this.loadingThings = true;
         let busObj: StockReplenishmentsBus = new StockReplenishmentsBus();
         busObj.branches = [];
         busObj.persons = [];

         if (CommonFunctions.hasValue(this.stockReplenishmentDetailBranch)) {
             busObj.branches = _.cloneDeep(this.stockReplenishmentDetailBranch.getChanged());
         }

         if (CommonFunctions.hasValue(this.stockReplenishmentDetailPerson)) {
             busObj.persons = _.cloneDeep(this.stockReplenishmentDetailPerson.getChanged());
         }

         this.svc_data.saveStockReplenishment(busObj).subscribe(
             data => {
                 this.globals.notifySuccess("Stock Replenishment saved successfully");
                 this.loadData();
             },
            err => { this.CallFailed(err) }
        );
    }

    SaveEmployeeSuccess(data: any) {

        this.loadingThings = false;
        if (!data.saveError) {
            this.id = data.primaryId;

            this.loadData( );
            this.saveSuccess();
        }
        else {

            this.saveError(data.message);
        }
    }
    CallFailed(err) {
        console.log("error: ", err);
       this.loadingThings = false;
        this.saveError(err)

    }
    clear() {
        this.data = {} as InventoryBus; //new EmployeeBus();
        this.data.inventoryLocationXrefBuss = [];
        this.data.inventorySupplierXrefBuss = [];
        this.data.inventoryThresholdOverrides = [];
        this.data.inventoryThresholdOverrideBranchs = [];
        this.data.inventoryConsMatchesBuss = [];
        this.data.inventoryConsumablesBuss = [];
        this.editForm.reset();
    }

    cancel() {

        this.data = _.cloneDeep(this.originalData);
        this.setForm();
        this.setPristine();
        this.editForm.markAsPristine();

    }
}
